
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-to-medicare",
      function () {
        return require("private-next-pages/new-to-medicare.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-to-medicare"])
      });
    }
  